var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 17V24C31.6667 26.8003 31.6667 28.2004 31.1218 29.27C30.6424 30.2108 29.8775 30.9757 28.9367 31.455C27.8671 32 26.467 32 23.6667 32H9.66675C6.86649 32 5.46635 32 4.3968 31.455C3.45599 30.9757 2.69108 30.2108 2.21172 29.27C1.66675 28.2004 1.66675 26.8003 1.66675 24V17M23.3334 8.66667L16.6667 2M16.6667 2L10.0001 8.66667M16.6667 2V22",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2899a56d05630deb3bd62ecb5545130e.svg";
export { ForwardRef as ReactComponent };